const userRoles = {
  user: 'user',
  admin: 'admin',
  wpUser: 'wpUser',
};

export default userRoles;
